import React, { useState } from 'react';
import { Form, Input, InputNumber, Button, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import {
  useUpdateOneHideAndSeekMutation,
  useFindFirstHideAndSeekQuery,
  useDeleteManyHideAndSeekNpcMutation,
  useHideAndSeekNpcsQuery,
} from '@src/components/generated/graphql';
import { openNotification } from 'util/helpers';
import styles from './hide-and-seek-settings.module.css';
import { avatarsGLTFURL, propsGLTFURL } from './hide-and-seek-npcs';

const notify = (type, msg, desc) => {
  openNotification(msg, desc, 'top', 2, type);
};

const HideAndSeekSettings = ({ hideAndSeekId, sceneId }) => {
  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [disableBtn, setDisableBtn] = useState(true);
  const [hasDefaultModal, setHasDefaultModal] = useState(false);
  const [updateHideAndSeek] = useUpdateOneHideAndSeekMutation();
  const [deleteHideAndSeekNPC] = useDeleteManyHideAndSeekNpcMutation();

  const [i, setI] = useState(1);
  const [j, setJ] = useState(1);

  const { data, loading, error } = useFindFirstHideAndSeekQuery({
    variables: {
      where: {
        id: {
          equals: hideAndSeekId,
        },
      },
    },
    fetchPolicy: 'no-cache',
  });

  const {
    data: dataNPC,
    loading: loadingNPC,
    error: errorNPC,
  } = useHideAndSeekNpcsQuery({
    variables: {
      where: {
        hideAndSeekId: {
          equals: hideAndSeekId,
        },
      },
    },
    fetchPolicy: 'no-cache',
  });

  function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min) + min); // The maximum is exclusive and the minimum is inclusive
  }

  async function onFinish(values) {
    setLoadingUpdate(true);

    //clean previous players info
    await deleteHideAndSeekNPC({
      variables: {
        where: {
          hideAndSeekId: {
            equals: hideAndSeekId,
          },
        },
      },
    });

    /* Test data for hide and seek 
      TODO: create interface for editing avatars and use it for updating
      TODO: use the proper types
    */

    //randomize
    const updateData: any = [];

    for (let i = 0; i < values.avatarNumber; i++) {
      const avatarIndex = getRandomInt(0, avatarsGLTFURL.length);
      const propIndex = getRandomInt(0, propsGLTFURL.length);
      updateData.push({
        assetUrl: avatarsGLTFURL[avatarIndex],
        propUrl: propsGLTFURL[propIndex].url,
      });
    }

    const res = await updateHideAndSeek({
      variables: {
        data: {
          finishPrompt: {
            set: 'You have captured all!',
          },
          startPrompt: {
            set: 'Welcome to ozone hide and seek. Press start hide and seek to start game',
          },
          hideAndSeekNPCs: {
            createMany: {
              data: updateData,
            },
          },
        },
        where: {
          id: hideAndSeekId,
        },
      },
    });

    setLoadingUpdate(false);

    // if (res?.data?.updateHideAndSeek?.status === 'success') {
    notify('success', 'Successfully', 'saved changes');
    setDisableBtn(true);
    // } else {
    // openNotification(
    //   'error',
    //   'Error',
    //   'something went wrong please try again'
    // );
    // }
  }

  if (loading || error || loadingNPC || errorNPC) {
    return (
      <Spin
        style={{ marginLeft: '45%', marginTop: 40 }}
        indicator={<LoadingOutlined style={{ fontSize: 40 }} spin />}
      ></Spin>
    );
  }

  const hideAndSeek = data?.findFirstHideAndSeek;
  const hideAndSeekNPC = dataNPC?.hideAndSeekNPCS;

  return (
    <div className={styles.formContainer}>
      <Form
        layout='vertical'
        onFinish={onFinish}
        onValuesChange={() => setDisableBtn(false)}
      >
        <p className={styles.title}>General Settings</p>
        <Form.Item
          label='Search time in seconds'
          name='time'
          initialValue={hideAndSeek?.searchTime}
        >
          <Input placeholder='60'></Input>
        </Form.Item>

        <Form.Item
          label='Numbers of avatars to find'
          name='avatarNumber'
          initialValue={hideAndSeekNPC?.length}
        >
          <InputNumber placeholder='7' min={1} max={10}></InputNumber>
        </Form.Item>

        {/*TODO: complete with interface for selecting avatars and props */}
        {/* 
        <p className={styles.title}>Avatars Selection</p>

        <p className={styles.title}>Props Selection</p> */}

        <div className={styles.btnWrapper}>
          <Button
            htmlType='submit'
            type='primary'
            className={styles.btn}
            disabled={loadingUpdate || disableBtn}
          >
            {loadingUpdate ? (
              <Spin
                indicator={
                  <LoadingOutlined
                    style={{ fontSize: 30, color: '#fff' }}
                    spin
                  />
                }
              ></Spin>
            ) : (
              'Save Changes'
            )}
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default HideAndSeekSettings;
